export default __webpack_public_path__ + "static/media/cloud.2edd3efb.png";